import WithdrawHistoryManagement from "./withdraw-history-management.page";

export default WithdrawHistoryManagement;
